// extracted by mini-css-extract-plugin
export var addToCartButton = "_qy-b";
export var arrowButtonContainer = "_qy-9";
export var arrowButtonIcon = "_qy-a";
export var carouselArrowButton = "_qy-6";
export var carouselElementContainer = "_qy-1";
export var left = "_qy-7";
export var productDisplayCarouselContainer = "_qy-0";
export var productTileContainer = "_qy-2";
export var productTileImage = "_qy-4";
export var productTileImageContainer = "_qy-3";
export var productTileTitle = "_qy-5";
export var right = "_qy-8";
export var sliderOverflow = "_qy-c";